import React from 'react';
import "./Productinfo.css";
import Product from './product';

import product1 from './images/pro1.jpg';
import product2 from './images/pro2.jpg';
import product3 from './images/pro3.jpg';
import product4 from './images/pro4.jpg';
import product5 from './images/pro5.jpg';
import product6 from './images/pro6.jpg';
import product7 from './images/pro7.jpg';
import product8 from './images/pro12.jpg';
import product9 from './images/pro9.jpg';
import product10 from './images/pro10.jpg';
import product11 from './images/pro11.png';
import product12 from './images/pro8.jpg';
import product13 from './images/r1p13.jpg';
import product14 from './images/pro14.jpg';
import product15 from './images/r1p1.jpg';
import product16 from './images/r1p14.jpg';
import product17  from './images/pro17.jpg';
import product18 from './images/pro18.jpg';
import product19 from './images/pro19.jpg';
import product20 from './images/pro8.jpg';
import product21 from './images/pro21.jpeg';
import product22 from './images/pro22.jpeg';
import product23 from './images/pro23.jpeg';
import product24 from './images/pro24.jpeg';
import product25  from './images/pro25.jpeg';
import product26 from './images/pro26.jpg';

function productinfo() {
  return (
        <div className='iteams__container'>
        
        <div className='pro_iteam_row row1'>
        <Product 
        id="123451"
        title='ASUS ZenBook 13 Ultra-Slim Laptop”  16GB, 512GB SSD, NumberPad, Thunderb...
        ASUS ZenBook 13 Ultra-Slim Laptop, 13.3” Intel Evo Platform i7-1165G7, 16GB, 512GB SSD, NumberPad, Thunderbolt 4, Wi-Fi 6, Windows 11 Pro, AI Noise-Cancellation,'
        price={82990}
        rating={5}
        image={product1}
        />

        <Product 
        id="123452"
        title='Ant Esports KM540 Gaming Backlit Keyboard and Mouse Combo, LED Wired Gaming Keyboard, Ergonomic & Wrist Rest Keyboard, Programmable Gaming Mouse for PC/Laptop/Mac – Black'
        price={6789}
        rating={5}
        image={product2}
        />

        </div>

        <div className='pro_iteam_row row2'>
        <Product 
        id="123453"
        title='Intel 12th Gen. i7-12650H, 40CM FHD 144Hz Gaming Laptop(16GB/1TB ,11 Home/Nvidia RTX3060 6GB GDDR6/Black/2.25Kg)'
        price={45090}
        rating={4}
        image={product3}
        />

        <Product 
        id="123454"
        title='Gaming Backlit Keyboard and Mouse Combo,LED Wired Gaming Keyboard,Ergonomic & Wrist Rest Keyboard, Programmable Gaming Mouse.'
        price={18899}
        rating={4}
        image={product4}
        />

        <Product 
        id="123455"
        title='Redgear Cosmo 7,1 Usb Gaming Wired Over Ear Headphones With Mic With Virtual Surround Sound,50Mm Driver, Rgb Leds & Remote Control(Blue)'
        price={11799}
        rating={4}
        image={product5}
        />
        </div>

        <div className='pro_iteam_row row3'>
        <Product 
        id="123456"
        title='OnePlus 11 5G | 8GB RAM+128GB | Titan Black | US Factory Unlocked Android Smartphone | 5000 mAh battery '
        price={35869}
        rating={4}
        image={product6}
        />

        <Product 
        id="123457"
        title='SAMSUNG Galaxy Z Fold 4 Cell Phone, Factory Unlocked Android Smartphone, 256GB,with Flex Mode'
        price={89789}
        rating={4}
        image={product7}
        />

        <Product 
        id="123458"
        title='Redgear Gaming Wired Remote Control Headphone'
        price={9998}
        rating={4}
        image={product8}
        />
        </div>
      
        <div className='pro_iteam_row row4'>
        <Product 
        id="123459"
        title='CeraVe Moisturizing Cream | Body and Face Moisturizer for Dry Skin'
        price={1799}
        rating={4}
        image={product9}
        />
        
        <Product 
        id="123410"
        title='Programmable Gaming Mouse for PC/Laptop/Mac – Black'
        price={1990}
        rating={5}
        image={product10}
        />

        <Product 
        id="123411"
        title='Sumsung Hd Compertable LCD '
        price={4199}
        rating={4}
        image={product11}
        />
         <Product 
        id="123412"
        title='Royle Gaming Chair for Gamers'
        price={5090}
        rating={5}
        image={product12}
        />

        </div>

        <div className='pro_iteam_row row5'>
        <Product 
        id="123415"
        title='MSI Katana GF66, 144Hz Fast Gaming Headphone'
        price={1990}
        rating={3}
        image={product13}
        />

        <Product 
        id="123416"
        title='Esports Gaming suport wifi Enjoy Gaming with No lag'
        price={7899}
        rating={3}
        image={product14}
        />

        <Product 
        id="123417"
        title='Intel 12th Gen.i7-12650H, 40CM FHD 144Hz Gaming Desktop'
        price={49998}
        rating={4}
        image={product15}
        />

        <Product 
        id="123418"
        title='Buffalo Check Plaid Throw Pillow Covers Cushion Case Polyester Linen for Fall Home'
        price={1699}
        rating={4}
        image={product16}
        />


        </div>

        <div className='pro_iteam_row row6'>
        <Product 
        id="123420"
        title='Nokia keypad mobile'
        price={1990}
        rating={5}
        image={product17}
        />
         <Product 
        id="123421"
        title='Pocket Drug Guide BOOK'
        price={1990}
        rating={3}
        image={product18}
        />

        <Product 
        id="123422"
        title= "Mans stylish sonata watch"
        price={2199}
        rating={4}
        image={product19}
        />
    <Product 
        id="123423"
        title='Royal Gaming Compertable Chair'
        price={5899}
        rating={4}
        image={product20}
        />

        <Product 
        id="123424"
        title=" Lewic  Glramous Man's Gray hodies"
        price={4598}
        rating={4}
        image={product21}
        />

        </div>


    <div className='pro_iteam_row home7'>
        <Product 
        id="123413"
        title= "Lewic  Glramous Man's Gray hodies(Black)"
        price={5699}
        rating={4}
        image={product22}
        />
         <Product 
        id="123419"
        title='Hp Laptop Carrying bag'
        price={2479}
        rating={4}
        image={product23}
        />

    <Product 
        id="123414"
        title="Watch shows how's your time going on!"
        price={4899}
        rating={3}
        image={product24}
        />

    <Product 
        id="123425"
        title="Black stylish Man's T-shirt"
        price={1899}
        rating={4}
        image={product25}
        />
    <Product 
        id="123425"
        title=' Increase your Motivation by reading this book'
        price={1499}
        rating={4}
        image={product26}
        />
    </div>


    </div>
      
  )
}

export default productinfo;
